import type { FormattersInitializer } from 'typesafe-i18n'
import type { Locales, Formatters } from './i18n-types.js'

export const initFormatters: FormattersInitializer<Locales, Formatters> = () => {
  const listFormatter = (items: string[], separator = ', ', lastSeparator = ' & ') => {
    if (items.length === 0) {
      return '';
    } else if (items.length === 1) {
      return items[0];
    } else if (items.length === 2) {
      return `${items[0]}${lastSeparator}${items[1]}`;
    } else {
      const lastItem = items.pop();
      return `${items.join(separator)}${lastSeparator}${lastItem}`;
    }
  }

	const formatters: Formatters = {
		list: listFormatter
	}

	return formatters
}
